import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './maintenance-model.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const MaintenanceModelDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const maintenanceModelEntity = useAppSelector(state => state.maintenanceModel.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="maintenanceModelDetailsHeading">
          <Translate contentKey="fleetSenseApp.maintenanceModel.detail.title">MaintenanceModel</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{maintenanceModelEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fleetSenseApp.maintenanceModel.name">Name</Translate>
            </span>
          </dt>
          <dd>{maintenanceModelEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fleetSenseApp.maintenanceModel.description">Description</Translate>
            </span>
          </dt>
          <dd>{maintenanceModelEntity.description}</dd>
          <dt>
            <Translate contentKey="fleetSenseApp.maintenanceModel.company">Company</Translate>
          </dt>
          <dd>{maintenanceModelEntity.company ? maintenanceModelEntity.company.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/maintenance-model" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/maintenance-model/${maintenanceModelEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MaintenanceModelDetail;
